module.exports = __webpack_public_path__ + "img/c60b06d.jpg";